export const quickConnectsColumns = [
  {
    label: "Name",
    id: "name",
    flex: 1,
    minWidth: 480,
    sortable: true,
  },
  {
    label: "Phone No.",
    id: "phoneNumber",
    flex: 1,
    minWidth: 480,
    sortable: true,
  },
];

export const quickConnectsFilterColumns = [
  {
    id: "0",
    label: "All",
    value: "all",
  },
  {
    id: "1",
    label: "External",
    value: "phone_number",
  },
  {
    id: "2",
    label: "Agent",
    value: "agent",
  },
  {
    id: "3",
    label: "Queue",
    value: "queue",
  },
];
